import { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";

//Components
import {
    Grid,
    Typography,
    Container,
    Paper,
    Divider
} from "@mui/material";
import { Button } from "@gpstrackit/react-controls"

//Views
import CreateEditSimProviderAccount from 'Modules/simProviderAccounts/views/.components/createEditSimProviderAccount';
import DeleteSimProviderAccount from 'Modules/simProviderAccounts/views/.components/deleteSimProviderAccount';
import DataView from 'Components/DataView';

//Security
import { HasPermission } from "Core/security";

//Actions
import { simProviderAccountCreateEditOpenModal, simProviderAccountsDeleteOpenModal } from 'Redux/actions'

const SimProviderAccountMain = (props) => {
    const { messages } = useIntl();
    const tableRef = useRef();
    const dispatch = useDispatch();

    const user = useSelector(state => state.securityRedux.user);
    const lang = useSelector(state => state.commonRedux.language);

    const [columns, setColumns] = useState([
        {
            key: "name",
            field: "name",
            title: messages['sim_provider_accounts_name'],
            width: 200,
            show: true,
            sort: true,
            locked: false,
            resize: true,
            export: true,
            functionString: 'return row?.name',
            code: "sim_provider_accounts_name",
            render: (item) => {
                return <span>{item?.name}</span>
            }
        },
        {
            key: "simProvider_name",
            field: "simProvider.name",
            title: messages['sim_provider_accounts_sim_provider'],
            show: true,
            sort: true,
            locked: false,
            resize: true,
            export: true,
            functionString: 'return row?.simProvider?.name',
            code: "sim_provider_accounts_sim_provider",
            render: (item) => {
                return <span>{item?.simProvider?.name}</span>
            }
        },
        {
            key: "simType",
            field: "simType",
            title: messages['sim_provider_accounts_sim_type'],
            show: true,
            locked: false,
            resize: true,
            export: true,
            functionString: 'return row?.simType',
            code: "sim_provider_accounts_sim_type",
            render: (item) => {
                return <span>{item?.simType}</span>
            }
        }
    ])

    const [total, setTotal] = useState(0);

    return (
        <Container maxWidth={false} className="container-view">
            <Paper elevation={0}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8", height: '95v' }}
                >
                    <Grid item xs={6}>
                        <Typography variant="h5" gutterBottom component="div">
                            {messages['sim_provider_accounts_title']} ({total})
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className="main-view-buttons">
                        <Button
                            disabled={!HasPermission(user, "simpa", "c")}
                            className="btn-dark-blue"
                            onClick={(e) => dispatch(simProviderAccountCreateEditOpenModal(true))}
                        >
                            {messages['sim_provider_accounts_add']}
                        </Button>
                    </Grid>
                    <div style={{ width: '100%', marginBottom: 10, marginTop: 5 }}>
                        <Divider style={{ backgroundColor: '#999999' }} />
                    </div>
                    <DataView
                        ref={tableRef}
                        exportName="simprovideraccounts"
                        dinamicQuery
                        name="sim-providers-accounts-v1"
                        entity="sim-provider-accounts"
                        graphqlFunction="searchSimProviderAccounts"
                        graphqlSort="SimProviderAccountSortInput"
                        graphqlConditions="SimProviderAccountSearchInput"
                        customQuery="id"
                        columns={columns}
                        hideAllInPagination
                        asyncSelect
                        searchConditions={["name"]}
                        searchOptionValue="id"
                        searchOptionLabel="name"
                        onChangeConditions={(tags, conditions, total, newColumns, rows, sort) => {
                            let currentConditions = {}
                            let currentTags = {}
                            if (!conditions && tags) {
                                currentConditions = tableRef?.current?.conditions;
                                currentTags = tags;
                            } else {
                                currentConditions = conditions || [];
                                currentTags = currentConditions?.filter((x) => x?.tags)[0]?.tags || [];
                                if (currentTags && currentTags.length > 0) tableRef?.current?.setTags(currentTags);
                            }

                            currentConditions = currentConditions?.filter((item) => item?.fields[0] !== 'id' && item?.fields[0] !== 'name');

                            let tagsById = currentTags.filter((item) => typeof item.id === "number");
                            if (tagsById?.length > 0) {
                                //New Items
                                let currentIds = tagsById.map((item) => (item.id));
                                if (currentIds.length > 0) {
                                    currentConditions.push({ fields: ["id"], terms: currentIds, exact: true, tags: currentTags, conditionOperator: "OR" });
                                }
                            }
                            let tagsByLabel = currentTags.filter(item => typeof item.id === "string")
                            if (tagsByLabel.length > 0) {
                                let currentLabels = tagsByLabel.map((item) => (item.name))
                                if (currentLabels.length > 0) {
                                    currentConditions.push({ fields: ["name"], terms: currentLabels, exact: false, tags: currentTags, conditionOperator: "OR" })
                                }
                            }

                            if (!conditions && tags) tableRef?.current?.getData(null, null, null, currentConditions, newColumns);
                            else tableRef?.current?.getData(null, rows, sort, currentConditions);
                        }}
                        searchFields={["name"]}
                        topheight={200}
                        onChangeTotal={(total) => setTotal(total)}
                        noSplit
                        onChangeColumns={(items) => setColumns(items)}
                        tableButtons={["export", 'orderColumn']}
                        noFilters
                        options={[
                            {
                                id: "edit-sim-provider-account",
                                label: messages['edit'],
                                single: true,
                                show: true,
                                disabled: !HasPermission(user, "simpa", "u"),
                                action: (items) => {
                                    dispatch(simProviderAccountCreateEditOpenModal(true, items[0]))
                                }
                            },
                            {
                                id: "delete-sim-provider-account",
                                label: messages['delete'],
                                single: true,
                                show: true,
                                disabled: !HasPermission(user, "simpa", "d"),
                                action: (items) => {
                                    dispatch(simProviderAccountsDeleteOpenModal(true, items[0]))
                                }
                            }
                        ]}
                        onClickMenu={(event, item) => {
                            if (event === messages['edit']) {
                                if (HasPermission(user, "simpa", "u")) {
                                    dispatch(simProviderAccountCreateEditOpenModal(true, item))
                                } else {
                                    NotificationManager.warning(
                                        messages['common_error_permission'],
                                        messages['sim_provider_accounts_edit_title'],
                                        5000,
                                    );
                                }
                            }
                            if (event === messages['delete']) {
                                if (HasPermission(user, "simpa", "d")) {
                                    dispatch(simProviderAccountsDeleteOpenModal(true, item))
                                } else {
                                    NotificationManager.warning(
                                        messages['common_error_permission'],
                                        messages['sim_provider_accounts_delete_title'],
                                        5000,
                                    );
                                }
                            }
                        }}
                        menuOptions={() => {
                            return [
                                messages['edit'],
                                messages['delete']
                            ]
                        }}
                    />
                </Grid>
            </Paper>
            <CreateEditSimProviderAccount tableRef={tableRef} />
            <DeleteSimProviderAccount tableRef={tableRef} />
        </Container>
    )
}
export default SimProviderAccountMain;